import {
  ControlsEdge,
  ExceptionType,
  GetComplianceFrameworkControlsDocument,
  ListExceptionGroupsDocument,
} from "~/operations";
import { Exceptions } from "~/components/exceptions/exceptions";
import { useFrameworkContext } from "~/pages/compliance/Framework/Framework";
import { Table, TableCell, TableHead, TableRow, useTheme } from "@mui/material";
import { CompletionBar } from "~/components/Completion/CompletionBar";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ExceptionGroup } from "~/pages/findings/Exceptions/types";
import { setDocumentTitle } from "~/lib/commonUtils";

export type FrameworkExceptionsProps = {};

export function FrameworkExceptions({}: FrameworkExceptionsProps) {
  const { space, framework, exceptionGroups, isLoading } =
    useFrameworkContext();
  const [searchParams] = useSearchParams();
  const params = useParams();
  const theme = useTheme();

  setDocumentTitle(["Exceptions", framework.name, "Compliance", space.name]);

  return (
    <Exceptions
      isLoading={isLoading}
      findingMrn={framework.mrn}
      emptyStateType="framework-exceptions"
      exceptionTypes={[ExceptionType.Compliance]}
      refetchQueries={[
        ListExceptionGroupsDocument,
        {
          query: GetComplianceFrameworkControlsDocument,
          variables: {
            input: {
              frameworkMrn: framework.mrn,
              scopeMrn: space.mrn,
            },
            controlsInput: {
              after: null,
              limit: 50,
            },
          },
        },
      ]}
      exceptionGroups={exceptionGroups}
      renderTable={function (exceptionGroup: ExceptionGroup) {
        const controls = exceptionGroup.exceptions;
        return (
          <>
            <Table
              sx={{
                borderRadius: 1,
                overflow: "hidden",
                "& a:last-child td": {
                  borderBottom: "none",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "background.lighter",
                    "&:hover": { backgroundColor: "background.lighter" },
                  }}
                >
                  <TableCell sx={{ width: "40%" }}>Control</TableCell>
                  <TableCell>Assets</TableCell>
                  <TableCell sx={{ width: "20%" }}>Completion</TableCell>
                  <TableCell>Framework</TableCell>
                </TableRow>
              </TableHead>
              {(controls as ControlsEdge[]).map((control) => {
                const { node } = control;
                const controlHref = () => {
                  const spaceId = searchParams.get("spaceId");
                  const frameworkMrn = searchParams.get("frameworkMrn");
                  const frameworkId = params.frameworkId;
                  const controlMrn = node?.mrn;
                  const controlId = node?.mrn.split("/").pop();
                  return `/space/compliance/${frameworkId}/controls/${controlId}?spaceId=${spaceId}&frameworkMrn=${frameworkMrn}&controlMrn=${controlMrn}`;
                };

                return (
                  <TableRow
                    key={node?.mrn}
                    component={Link}
                    to={controlHref()}
                    sx={{
                      cursor: "pointer",
                      backgroundColor: "background.light",
                    }}
                  >
                    <TableCell sx={{ width: "40%" }}>{node?.title}</TableCell>
                    <TableCell>{node?.assetsStats.totalAssets}</TableCell>
                    <TableCell sx={{ width: "20%" }}>
                      <CompletionBar
                        percent={Number(node?.completion)}
                        height={theme.spacing(1)}
                        tooltip={`Completion: ${node?.completion}%`}
                      />
                    </TableCell>
                    <TableCell>
                      {node?.framework?.name} {node?.framework?.version}
                    </TableCell>
                  </TableRow>
                );
              })}
            </Table>
          </>
        );
      }}
    />
  );
}
